
import socket from '@/communications/socketCluster/socket'
import xxhash from 'xxhashjs'
import isNil from 'lodash/isNil'
import isArray from 'lodash/isArray'
import isString from 'lodash/isString'

export const authenticated = state => {
  return state.authenticated
}

export const role = state => {
  return state.user.role
}

export const isAllowed = (state) => (permission) => {
  if (state.user.role === 'admin') {
    return true
  } else if (isArray(permission)) {
    // Returns true if EVERY required permission is included in user's abilities
    return permission.every(p => state.user.abilities.includes(p))
  } else if (isString(permission)) {
    return state.user.abilities.includes(permission)
  } else {
    console.error('Unsupported Permission Object', permission)
    return false
  }
}

export const isPoser = state => {
  let authToken = socket.authToken
  return authToken && authToken.hasOwnProperty('poser') && authToken.poser
}

export const token = state => {
  let authToken = SC.getSocket().authToken
  if (isNil(authToken)) {
    return false
  } else {
    xxhash.h32(JSON.stringify(authToken), 0xCAFEBABE).toString(16)
  }
}

export const appVersion = state => {
  return state.packageVersion
}
